import React from 'react'
import { FeatherLoader } from '@abroad/components'
import loadable from '@loadable/component'

const LoadableCKEditor = loadable(() => import('./CKEditor'), {
  fallback: <FeatherLoader width={60} />,
})

export default LoadableCKEditor
